module.exports = "../study/imgs/maps/Kanagawa/S8/Hazard/Slopefailure/Kanagawa_Slopefailure_MRI_RCP85_Mid.png";